module.exports = __webpack_public_path__ + "static/TalonStrike_SoftwareSolutions_White-aca5d405f572522264f2b85600e9acd6.png";